import { useLang } from 'hooks/lang';

import {
  actions,
  FullProject,
  invoiceControlStatusConfig,
  projectInvoiceStatusConfig,
  quotationRequestConfig,
  calculateProjectTotal,
} from 'entities';

import { Button } from 'components/Blocks';
import { CheckIcon } from 'components/Icons';

import { useProjectProfile } from 'pages/Projects/ProjectProfile/context';

function canMark({ invoice, services }: FullProject): boolean {
  if (invoice.type !== 'STANDARD') return false;

  const errors = [
    !!Number(calculateProjectTotal(services)),

    invoiceControlStatusConfig.readyToInvoice.code !== invoice.status,

    invoice.quotationRequests.some(
      ({ status }) => quotationRequestConfig.waitingResponse.code === status,
    ),

    invoice.projectInvoices.some(
      ({ status }) => projectInvoiceStatusConfig.canceled.code !== status,
    ),
  ];

  return errors.every((x) => !x);
}

export function MarkAsPaid() {
  const { project, updateProject } = useProjectProfile();

  const { t } = useLang();

  const markAsPaid = actions.invoice.markProjectAsPaid.use({
    params: {
      project: project.id,
    },

    onSuccess: () => {
      updateProject((old) => ({
        ...old,

        invoice: {
          ...old.invoice,

          status: invoiceControlStatusConfig.paid.code,
        },
      }));
    },
  });

  if (!canMark(project)) return null;

  return (
    <Button {...markAsPaid.buttonProps} variant="ghost">
      <CheckIcon size={20} />
      {t('mark-as-paid')}
    </Button>
  );
}
